import { render } from "./AppUsers.vue?vue&type=template&id=05983b71&scoped=true"
import script from "./AppUsers.vue?vue&type=script&lang=js"
export * from "./AppUsers.vue?vue&type=script&lang=js"

import "./widget.css?vue&type=style&index=0&id=05983b71&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05983b71"]])

export default __exports__